import React from "react";

import { useRouter } from "../../context/RouterContext";
import { IconButton } from "./IconButton";
import * as styles from "./ManageMenu.scss";
import { SettingsButton } from "./SettingsButton";

export interface IManageMenuProps {
    onClose: () => void;
}

export function ManageMenu(props: IManageMenuProps) {
    const { onClose } = props;
    const { routeTo } = useRouter();

    const hideSettings = false;
    const hideApplications = true;

    return (
        <div className={styles["manage-menu"]}>
            <div className={styles.entries}>
                <>
                    {!hideSettings && (
                        <SettingsButton
                            data-testid="sidebar-button-settings"
                            onClicked={onClose}
                        >
                            Settings
                        </SettingsButton>
                    )}
                    {!hideApplications && (
                        <IconButton
                            data-testid="sidebar-button-applications"
                            icon="utility"
                            to={routeTo.applications()}
                            onClicked={onClose}
                        >
                            Applications
                        </IconButton>
                    )}
                </>
                <IconButton
                    data-testid="add-device-button-applications"
                    icon="add"
                    to={routeTo.createDevice()}
                    onClicked={onClose}
                >
                    Add Device
                </IconButton>
                <IconButton
                    data-testid="help-button-applications"
                    icon="help"
                    to={"https://docs.formant.io/docs"}
                    onClicked={onClose}
                >
                    Help
                </IconButton>
            </div>
        </div>
    );
}
